var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaoTalkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0359 17.2735C17.1308 17.2735 22.0717 13.4067 22.0717 8.63676C22.0717 3.86681 17.1308 0 11.0359 0C4.94092 0 0 3.86681 0 8.63676C0 11.7344 2.0838 14.4512 5.21422 15.9754L4.70567 18.0605C4.48729 18.9559 5.49353 19.6449 6.24937 19.1176L9.08531 17.139C9.71844 17.2274 10.3703 17.2735 11.0359 17.2735Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoTalkLogo);
export default __webpack_public_path__ + "static/media/kakaoTalkLogo.940572d92cbf9f959893b16b08e16572.svg";
export { ForwardRef as ReactComponent };